import { c as _c } from "react/compiler-runtime";
import type { HofDashboardDocument } from '@/features/hof-dashboard/api/hof-dashboard-data';
import { formatFileSize, translate } from '@/features/hof-dashboard/texts';
import type { Locale } from '@/types/types';
import { Download, FileText } from 'lucide-react';
import type React from 'react';

/** Documents to download, each as one row that is a link as a whole. */
export const DocumentLinks: React.FC<{
  documents: HofDashboardDocument[];
  locale: Locale;
}> = t0 => {
  const $ = _c(7);
  const {
    documents,
    locale
  } = t0;
  let t1;
  if ($[0] !== documents || $[1] !== locale) {
    let t2;
    if ($[3] !== locale) {
      t2 = document => <li key={document.id}><a href={document.url} target="_blank" rel="noreferrer" className="group flex min-h-11 items-center justify-between gap-4 py-3 no-underline"><span className="flex min-w-0 items-start gap-3"><FileText className="mt-0.5 h-5 w-5 shrink-0 text-gray-500" aria-hidden={true} /><span className="min-w-0"><span className="block font-semibold break-words text-gray-900 group-hover:underline">{document.title}</span>{document.filesize !== undefined && <span className="text-xs text-gray-500">{formatFileSize(document.filesize, locale)}</span>}</span></span><span className="text-conveniat-green flex shrink-0 items-center gap-1.5 text-sm font-semibold"><Download className="h-4 w-4" aria-hidden={true} /><span className="sr-only @md:not-sr-only">{translate("download", locale)}</span></span></a></li>;
      $[3] = locale;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = documents.map(t2);
    $[0] = documents;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="divide-y divide-gray-100">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};